module.exports = __webpack_public_path__ + "static/media/whats_btn.be8fb0c9.png";